import { Link, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const AccountPage = () => {
  const { user, loading, isAdmin, signOut } = useAuth();

  if (loading) {
    return (
      <div className="pt-32 min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: "/account" }} replace />;

  return (
    <div className="pt-24 min-h-screen">
      <section className="py-12">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-4xl font-display tracking-widest mb-2">MY ACCOUNT</h1>
          <p className="text-muted-foreground font-body text-sm mb-10">{user.email}</p>

          <div className="grid gap-4">
            <div className="bg-panel border border-border p-6">
              <h2 className="font-display tracking-widest mb-2">PROFILE</h2>
              <p className="text-muted-foreground font-body text-sm">
                {user.user_metadata?.full_name || "—"}
              </p>
            </div>

            <div className="bg-panel border border-border p-6">
              <h2 className="font-display tracking-widest mb-2">BOOKINGS</h2>
              <p className="text-muted-foreground font-body text-sm">No bookings yet.</p>
            </div>

            <div className="bg-panel border border-border p-6">
              <h2 className="font-display tracking-widest mb-2">ORDERS</h2>
              <p className="text-muted-foreground font-body text-sm">No orders yet.</p>
            </div>

            <div className="flex flex-wrap gap-3 pt-4">
              {isAdmin && (
                <Link to="/admin">
                  <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-body font-semibold">
                    Open Admin
                  </Button>
                </Link>
              )}
              <Button variant="outline" onClick={signOut} className="font-body">
                Sign Out
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export { AccountPage };
export default AccountPage;
